import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 退職者認証コード参照API
import {
  IAPI_RET012_Request,
  IAPI_RET012_Response,
} from "../../../type/apiType";

// 退職者認証コード参照
// API仕様書_退職者
const httpAPI_RET012 = async (
  param: IAPI_RET012_Request
): Promise<IAPI_RET012_Response> => {
  let res = await http.post(ApiUrl.API_RET012, {
    ...param,
  });

  return res.data;
};

export { httpAPI_RET012 };
